import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApiClientService, LoginExtendedModel, Login, Iplog } from '../../services/api-client.service';
import { Md5 } from 'ts-md5';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  username: string = '';
  password: string = '';
  isLoading: boolean = false;
  errorMessage: string = '';

  constructor(
    private apiClient: ApiClientService,
    private router: Router
  ) { }

  async onSubmit() {
    // Basic validation
    if (!this.username || !this.password) {
      this.errorMessage = 'Please fill in all fields';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';

    try {
      const loginData: Login = new Login({
        username: this.username,
        password: Md5.hashStr(this.password)
      });

      const user: LoginExtendedModel = await this.apiClient.login(loginData);

      // Login successful - handle the response
      await this.handleLoginSuccess(user);

    } catch (error: any) {
      this.handleLoginError(error);
    } finally {
      this.isLoading = false;
    }
  }

  private async handleLoginSuccess(user: LoginExtendedModel) {
    console.log('Login successful:', user);

    // Store user data (you might want to use a service for this)
    localStorage.setItem('Agroinformer-Current-User', JSON.stringify(user));
    localStorage.setItem('authToken', user.token || '');

    var res = await this.getUserIP();
    let newIp = new Iplog();
    newIp.date = new Date();
    newIp.ip = res['ip'];
    newIp.username = user.username as string;
    await this.apiClient.ip(newIp);
    
    window.location.href = '/dashboard';
  }

  private handleLoginError(error: any) {
    console.error('Login error:', error);

    // Handle different error types
    if (error.status === 400) {
      this.errorMessage = 'Invalid username or password';
    } else if (error.status === 403) {
      this.errorMessage = 'Access denied. Please check your credentials.';
    } else if (error.status === 0) {
      this.errorMessage = 'Network error. Please check your connection.';
    } else {
      this.errorMessage = 'Login failed. Please try again.';
    }
  }

  // Clear error when user starts typing
  onInputChange() {
    if (this.errorMessage) {
      this.errorMessage = '';
    }
  }

  async getUserIP(): Promise<any> {
  try {
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();
    return {
      ip: data.ip,
      city: data.city,
      country: data.country_name,
      region: data.region,
      isp: data.org
    };
  } catch (error) {
    console.error('Error fetching IP from ipapi:', error);
  }
}
}
